<template>
  <BaseModal need-close-emit :title="$t('Import offer')" @close="handleModalClose">
    <template #header-action>
      <Button type="func" left-icon="question-circle" @click="openSupportChat">{{
        $t('I need help')
      }}</Button>
    </template>
    <template #default>
      <div class="two-form-items">
        <FormInput
          id="offer-company"
          v-model="form.company_name"
          required
          :label-text="$t('Company name')"
          :placeholder="$t('Enter company name...')"
          :error="get(errors, 'company_name', false)"
          :error-message="get(errors, 'company_name', '')"
          @input="clearError('company_name')"
        />
        <FormInput
          id="offer-email"
          v-model="form.email"
          :label-text="$t('Email')"
          :placeholder="$t('name@company.com')"
          :error="get(errors, 'email', false)"
          :error-message="get(errors, 'email', '')"
          @input="clearError('email')"
        />
      </div>
      <div class="two-form-items">
        <FormInput
          id="offer-contact"
          v-model="form.name"
          required
          :label-text="$t('Contact name')"
          :placeholder="$t('Enter contact name...')"
          :error="get(errors, 'name', false)"
          :error-message="get(errors, 'name', '')"
          @input="clearError('name')"
        />
        <FormInput
          id="offer-phone"
          v-model="form.phone_number"
          required
          :label-text="$t('Contact phone')"
          :placeholder="'+'"
          :error="get(errors, 'phone_number', false)"
          :error-message="get(errors, 'phone_number', '')"
          @input="clearError('phone_number')"
        />
      </div>
      <Autocomplete
        v-model="form.currency"
        :label-text="$t('Offer currency')"
        :items="currencyItems"
      />
      <FormTextArea
        id="offer-description"
        v-model="form.description"
        required
        :label-text="$t('Offer description')"
        :placeholder="$t('Describe what you offer...')"
        :error="get(errors, 'description', false)"
        :error-message="get(errors, 'description', '')"
        @input="clearError('description')"
      >
      </FormTextArea>
      <div class="spacey-12">
        <h3 class="text-h3">{{ $t('Excel file') }}</h3>
        <Button
          type="secondary"
          size="small"
          left-icon="excel"
          :loading="loadings.includes('modalTemplateText')"
          @click="downloadXlsxHandler({ loadingId: 'modalTemplateText' })"
        >
          {{ $t('Download Excel template') }}
        </Button>
        <FileAttachment
          :custom-label="$t('Download our Excel template, fill it in and upload here.')"
          :files="excelFile"
          :default-label="false"
          :max-size="10"
          :error="get(errors, 'proposal_file[0]', false)"
          @file-input="(files) => handleFileInput({ files, field: 'excel' })"
          @file-delete="handleFileDelete({ field: 'excel' })"
        />
      </div>

      <div class="spacey-12">
        <h3 class="text-h3">{{ $t('Additional files') }}</h3>
        <FileAttachment
          :default-label="false"
          :max-count="10"
          :disallowed-formats="['exe', 'dmg']"
          :files="additionalFiles"
          :is-loading="loadings.additionalFilesUpload"
          @file-input="(files) => handleFileInput({ files, field: 'additional' })"
          @file-delete="(idx) => handleFileDelete({ field: 'additional', idx })"
        />
      </div>
    </template>
    <template #footer>
      <div class="spacex-12 d-contents">
        <Button type="secondary" @click="handleModalClose">{{ $t('Close') }}</Button>
        <Button @click="submitOffer">{{ $t('Import offer') }}</Button>
      </div>
    </template>
  </BaseModal>
</template>

<script>
  import BaseModal from '@/components/ui/BaseModal';
  import Button from '@/components/ui-v2/Button';
  import FormInput from '@/components/ui/FormInput';
  import FormTextArea from '@/components/ui/FormTextArea';
  import FileAttachment from '@/components/projects/FileAttachment';
  import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
  import get from 'lodash.get';
  import Autocomplete from '@/components/ui/Autocomplete';
  import { openSupportChat } from '@/integrations';

  export default {
    name: 'CreateOfferModal',
    components: {
      BaseModal,
      Button,
      FormInput,
      FormTextArea,
      FileAttachment,
      Autocomplete,
    },
    computed: {
      ...mapState('publicTender', [
        'formHasBeenSubmitted',
        'form',
        'loadings',
        'additionalFiles',
        'errors',
        'submitLoading',
        'pdfFile',
        'isExcelModal',
        'excelFile',
      ]),
      ...mapGetters({
        currencyItems: 'global/currencySelectItems',
      }),
    },
    methods: {
      openSupportChat,
      get,
      ...mapActions({ closeBaseModal: 'modal/closeModal' }),
      ...mapActions('publicTender', [
        'submitOffer',
        'downloadXlsxHandler',
        'handleFileInput',
        'handleFileDelete',
        'closeModal',
      ]),
      ...mapMutations('publicTender', ['clearError']),
      handleModalClose() {
        this.closeModal();
        this.closeBaseModal();
      },
    },
  };
</script>

<style scoped></style>
